import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminStudentVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveStudent = createAsyncThunk<AdminStudentVM, string, { extra: Partial<Dependencies> }>(
  "students/retrieveStudent",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.getStudent(id);
  },
);

export const resetRetrieveStudent = createAction("students/resetRetrieveStudent");
